import { render, staticRenderFns } from "./EnrollLoyalty.vue?vue&type=template&id=b0066310&scoped=true"
import script from "./EnrollLoyalty.vue?vue&type=script&lang=js"
export * from "./EnrollLoyalty.vue?vue&type=script&lang=js"
import style0 from "./EnrollLoyalty.vue?vue&type=style&index=0&id=b0066310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0066310",
  null
  
)

export default component.exports